import {Button, Fade, Grid, ImageListItem, Modal} from "@mui/material";
import React, {useState} from "react";
import {Trans} from "react-i18next";
import {
  AttachmentDto,
  getAttachmentPresignedUris,
} from "../../features/attachment/attachment-api";

type ImageWithModalProps = {
  refImg?: any | null;
  item: AttachmentDto;
};

export const ImageWithModal = ({item, refImg}: ImageWithModalProps) => {
  const [open, setOpen] = useState(false);

  const {thumbnailUri, previewUri, fileUri} = getAttachmentPresignedUris(item);

  const handleClose = () => {
    setOpen(false);
  };

  const handleImage = () => {
    if (previewUri) {
      setOpen(true);
    } else {
      handleOpenInNewTab();
    }
  };

  const handleOpenInNewTab = () => {
    if (fileUri) {
      window.open(fileUri, "_blank");
    }
  };

  return (
    <>
      <ImageListItem key={item.attachmentId} sx={{borderRadius: "8px"}}>
        <img
          ref={refImg}
          style={{objectFit: "fill", cursor: "pointer"}}
          src={thumbnailUri}
          alt={item.description ?? ""}
          loading="lazy"
          onClick={handleImage}
        />
      </ImageListItem>
      <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
        sx={{display: "flex", alignItems: "center", justifyContent: "center"}}
      >
        <Grid
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: 2,
          }}
        >
          <Button
            onClick={handleOpenInNewTab}
            variant={"outlined"}
            color={"primary"}
            size={"medium"}
            sx={{alignSelf: "flex-end", height: "40px"}}
          >
            <Trans i18nKey={"imageWithModal.download"}>Download</Trans>
          </Button>
          <Fade in={open} timeout={500}>
            <img
              src={previewUri}
              alt="img"
              style={{maxHeight: "80vh", maxWidth: "80vw"}}
            />
          </Fade>
        </Grid>
      </Modal>
    </>
  );
};
